/* eslint-disable */
// @ts-nocheck

import {
  Assets,
  createTexture,
  getResolutionOfUrl,
  ImageSource,
  type Loader,
  type ResolvedAsset,
  type Texture,
  type TextureSourceOptions,
  WorkerManager,
} from 'pixi.js';

// fix for loading bundles that contain single images
// failing to load them would not trigger any error noticeable by pixi loader
export function applyLoadTextureRejectFix(): void {
  const parser = Assets.loader.parsers.find((p) => p.name === 'loadTextures');

  if (!parser) return;

  parser.load = async function loadTexture(
    url: string,
    asset: ResolvedAsset<TextureSourceOptions>,
    loader: Loader,
  ): Promise<Texture> {
    let src: any = null;

    if (globalThis.createImageBitmap && this.config.preferCreateImageBitmap) {
      if (this.config.preferWorkers && (await WorkerManager.isImageBitmapSupported())) {
        src = await WorkerManager.loadImageBitmap(url, asset);
      } else {
        src = await loadImageBitmap(url, asset);
      }
    } else {
      src = await new Promise((resolve, reject) => {
        src = new Image();
        src.crossOrigin = this.config.crossOrigin;

        src.src = url;
        if (src.complete) {
          resolve(src);
        } else {
          src.onload = (): void => {
            resolve(src);
          };

          // FIX HERE
          // in pixi there was no onerror handling which would result in forever hanging promise
          // there would be no indication that loading process failed
          src.onerror = (): void => {
            reject(src);
          };
        }
      });
    }

    const base = new ImageSource({
      resource: src,
      alphaMode: 'premultiply-alpha-on-upload',
      resolution: asset.data?.resolution || getResolutionOfUrl(url),
      ...asset.data,
    });

    return createTexture(base, loader, url);
  };
}
